import angular from 'angular';

import '../../../main/factory/device';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.module.device.activateDevice", [
]).controller("merchant.application.module.device.activateDevice.controller", [
    "$rootScope", "$scope", "$controller",
    "merchant.application.main.factory.device",
    function($rootScope, $scope, $controller, Device) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.activateDevice) {
            $scope.model.activateDevice = {};
        }

        $scope.model.currentError = null;

        $scope.submit = function() {
            if ($scope.form.$valid) {
                $scope.activateDevice();
            }
        };

        $scope.activateDevice = function() {
            $scope.model.currentError = null;
            Device.activateDevice($scope.model.activateDevice, function(response) {
                Device.deviceId(response.deviceId);
                Device.deviceKey(response.key);
            }, function(error) {
                // Suppress the global error handler as invalid_secret is returned as a 401
                if (error.status === 401) {
                    $rootScope.unauthorisedError = false;
                }
                $scope.model.currentError = error.data && error.data.errorCode;
            });
        };

    }
]);
